import { App } from "antd";
import $ from "jquery";
import { useCallback } from "react";
import { useFolderTree } from "@devowl-wp/react-folder-tree";
import { useBackboneFilterSelection } from "./useHandleSelect.js";
import { FILTER_SELECTOR } from "../../backbone/filter.js";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
import { rmlOpts } from "../../utils/rmlOpts.js";
function useFetchTree() {
    const { message } = App.useApp();
    const { treeStore } = useStores();
    const { set } = useFolderTree();
    const handleBackboneFilterSelection = useBackboneFilterSelection();
    return useCallback(async (setSelectedId)=>{
        set({
            isTreeBusy: true
        });
        try {
            const { slugs } = await treeStore.fetchTree(setSelectedId);
            $(FILTER_SELECTOR).each(function() {
                const backboneFilter = $(this).data("backboneView");
                backboneFilter && backboneFilter.createFilters(JSON.parse(JSON.stringify(slugs)), treeStore);
            });
            handleBackboneFilterSelection();
            if (treeStore.selected) {
                rmlOpts.others.lastQueried = treeStore.selected.id;
            }
        } catch (e) {
            message.error(e instanceof Error ? e.message : __("Could not load the folder tree."));
        } finally{
            set({
                isTreeBusy: false
            });
        }
    }, [
        treeStore,
        handleBackboneFilterSelection,
        message,
        set
    ]);
}
export { useFetchTree };
